<!-- @format -->

<template>
	<div class="border-box">
		<slot></slot>
	</div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
	.border-box {
		background: rgba(37, 40, 55, 0.5);
		border-radius: 8px;
		border: 1px solid rgba(226, 231, 245, 0.1);
		height: 100%;
		padding: 20px;
	}
</style>
